import React from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

import { NavLink } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../../assets/logo-light.svg";
import ParticlesAuth from "./ParticlesAuth";
import { Routes } from "../../../constants/Routes";
// @ts-ignore
import { loadAnimation } from "lottie-web";
import { defineLordIconElement } from "lord-icon-element";
import { useI18n } from "../../../i18n/I18nContext";
// register lottie and define custom element
defineLordIconElement(loadAnimation);

export default function ForgetPasswordPage() {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      // eslint-disable-next-line no-console
      console.log(values);
    },
  });
  const { translate } = useI18n();
  document.title = "Reset Password | Velzon - React Admin & Dashboard Template";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <NavLink to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="40" />
                  </NavLink>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">{translate("TITTLE_FORGOT_PASSWORD_MAIN")}</h5>
                    <p className="text-muted">{translate("TITTLE_FORGOT_RESET_PASSWORD_WITH")}</p>
                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    ></lord-icon>
                  </div>

                  <Alert
                    className="alert-borderless alert-warning text-center mb-2 mx-2"
                    role="alert"
                  >
                    {translate("TITTLE_FORGOT_PASSWORD_ENTER_EMAIL")}
                  </Alert>
                  <div className="p-2">
                    {/*{forgetError && forgetError ? (*/}
                    {/*  <Alert color="danger" style={{ marginTop: "13px" }}>*/}
                    {/*    {forgetError}*/}
                    {/*  </Alert>*/}
                    {/*) : null}*/}
                    {/*{forgetSuccessMsg ? (*/}
                    {/*  <Alert color="success" style={{ marginTop: "13px" }}>*/}
                    {/*    {forgetSuccessMsg}*/}
                    {/*  </Alert>*/}
                    {/*) : null}*/}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">{translate("TITTLE_LOGIN_EMAIL")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={!!(validation.touched.email && validation.errors.email)}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit">
                          {translate("TITTLE_FORGOT_PASSWORD_SEND_RESET")}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  {translate("TITTLE_FORGOT_PASSWORD_I_REMEMBER")}
                  <NavLink
                    to={Routes.LoginPage}
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {translate("TITTLE_FORGOT_CLICK_HERE")}
                  </NavLink>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
}
